$( document ).ready(function() { 

if ($("#shopify-section-product-template")[0]){
  
      $("img.product-featured-img").css("max-height", "800px");
     
      function personaliseButton(){
        $("body").on('DOMSubtreeModified', "#pw_personalisation_id", function() {
          
          	 var pw_button_text = $("#pw_cart_button").val();
          
             if(pw_button_text == "Personalise"){
               
                 $('#pw_cart_button').val('Edit');
                 $('#pw_cart_button').css("width","100% !important");
                 $(".pwAddToCart").show();
             }
             
        });
        
        
        // Select the node that will be observed for mutations
        var targetNode = document.getElementById('pw_personalisation_id');

        // Options for the observer (which mutations to observe)
        var config = { attributes: true, childList: true };

        // Callback function to execute when mutations are observed
        var callback = function(mutationsList) {
          //for(var mutation of mutationsList) {
          for(var mutation in mutationsList) {
            
               var pw_button_text = $("#pw_cart_button").val();
          
               if(pw_button_text == "Personalise"){
				 
                 $('#pw_cart_button').val('Edit');
                 $('#pw_cart_button').css("width","100% !important");
                 $(".pwAddToCart").show();
               }
          }

        };

        // Create an observer instance linked to the callback function
        var observer = new MutationObserver(callback);

        // Start observing the target node for configured mutations
        observer.observe(targetNode, config);
      }
    
  

      personaliseButton();
    
      var if_combination = $(".selector-wrapper").is(":visible");

      if(if_combination){


         setTimeout(function(){ 

           var num_of_variants = $(".selector-wrapper").length;

           var num_of_selected_variants = $(".selector-wrapper").length;


           if(num_of_variants != num_of_selected_variants){
                $("#pw_cart_button").attr('disabled', true);
                $(".pwAddToCart").attr('disabled', true);
           }

         }, 2000);

      }

      $(".selector-wrapper select option").on("click", function(e){
		
        var pw_cart_button = $("#pw_cart_button").html();
        if (typeof  pw_cart_button !== 'undefined'){
          
          
           var pw_button_text = $("#pw_cart_button").val();
			
           if(pw_button_text == "Edit"){
             var product_image_original = $('.feature-row__image.product-featured-img').attr("data-srcset");
             
             var product_image_original = product_image_original.split(",");
            
             var length = product_image_original.length;
             
             var product_image_original = product_image_original[length-1];
             
            
             $(".feature-row__image.product-featured-img").attr("src", product_image_original);
             $(".feature-row__image.product-featured-img").attr("srcset", product_image_original);
             
             if (document.documentMode || /Edge/.test(navigator.userAgent)) {
                $("#pw_cart_button").prop('value', 'Personalise');
             } else{
               
                $('#pw_cart_button').val('Personalise');
                
             }
           }
        
           var num_of_variants = $(".selector-wrapper").length;

           var num_of_selected_variants = $(".selector-wrapper").length;


           $(".pwAddToCart").hide();
		   		
           if(num_of_variants == num_of_selected_variants){
              $("#pw_cart_button").attr('disabled', false);

           }


        
         }

      });
  
  }

  // Disable the add to cart button until the product has been personalized
  var addToCart = $(document).find('.pwAddToCart');
  if (addToCart.length > 0) {
  	var personalisationId = $(document).find('#pw_personalisation_id');
  	if (personalisationId.length > 0) {
      setInterval(function() {
        // Check for personalisation id and enable the add to cart button if has any value
      	addToCart.attr('disabled', personalisationId.val() ? false: true);
      }, 1000);
    
  	}
  }
  
});